
    /**
    * Loops value inside range.
    */
    function loop(val, min, max){
        return val < min? max : (val > max? min : val);
    }

    module.exports = loop;




//////////////////
// WEBPACK FOOTER
// ./~/mout/math/loop.js
// module id = 1619
// module chunks = 0 1 2